export default import.meta.ROLLDOWN_FILE_URL_D1cPcQR8JGR3YSGfgIRyoQ